import { Field } from 'react-final-form';
import Radio from 'components/other/Radio';
import Icon from 'components/other/Icons';

import styles from './TestForm.module.scss';

const EtnTradesAmountField = field => (
  <div className={styles.FieldContainer} tabIndex="0">
    <p>Antall handler siste 12 mnd i ETN-er</p>
    <Field name="etnTradesAmount" type="radio" value="none">
      {({ input }) => (
        <label htmlFor="etnTradesAmount_none">
          <Radio
            id="etnTradesAmount_none"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Ingen
        </label>
      )}
    </Field>
    <Field name="etnTradesAmount" type="radio" value="lessThan10">
      {({ input }) => (
        <label htmlFor="etnTradesAmount_lessThan10">
          <Radio
            id="etnTradesAmount_lessThan10"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Færre enn 10
        </label>
      )}
    </Field>
    <Field name="etnTradesAmount" type="radio" value="moreThan10">
      {({ input }) => (
        <label htmlFor="etnTradesAmount_moreThan10">
          <Radio
            id="etnTradesAmount_moreThan10"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Flere enn 10
        </label>
      )}
    </Field>
    {field.meta.error && field.meta.touched && (
      <div className={styles.errorContainer}>
        <Icon icon="exclamation-triangle" />
        <span>{field.meta.error}</span>
      </div>
    )}
  </div>
);

export default EtnTradesAmountField;
